import React, { useState, Fragment } from 'react';
import LinearProgressBar from "~/components/progressBar/LinearProgressBar";
import { Info } from "react-feather";
import { Tooltip } from "reactstrap";


const UserLevel = ({user})=> {

  const [toggle, setToggle] = useState(false);

  return (
    <Fragment>
      <h4 id="No-Reversals" className="row mt-0 m-b-10 justify-content-center align-items-center">

        <div>Level {user.level} </div>
        { user.level !== 2 && <Info size={20} className="m-l-5" /> }

        <Tooltip
          placement="top"
          isOpen={toggle && user.level !== 2}
          toggle={()=> setToggle(!toggle)}
          target={"No-Reversals"}
        >
          Receving reversals for offers and surveys will stop your progress towards next level!
        </Tooltip>

      </h4>

      { user.level === 0 &&
        <div className="check-in-progress-container">

          <div className="overflow-hidden">
            <div className="pull-left">Target</div>
            <div className="pull-right">Points</div>
          </div>
          <LinearProgressBar start={0} end={10000}  progress={user.totalPoints} />

          <div className="overflow-hidden">
            <div className="pull-left">Target</div>
            <div className="pull-right">Cashout</div>
          </div>
          <LinearProgressBar start={0} end={1} progress={user.acceptedCashouts} />

        </div>
      }

      { user.level === 1 &&
        <div className="check-in-progress-container">

          <div className="overflow-hidden">
            <div className="pull-left">Target</div>
            <div className="pull-right"> {"1 Offer > 300pt"} </div>
          </div>
          <LinearProgressBar start={0} end={1}  progress={user.legitOffersCount} />

          <div className="overflow-hidden">
            <div className="pull-left">Target</div>
            <div className="pull-right">Cashout</div>
          </div>
          <LinearProgressBar start={0} end={3} progress={user.acceptedCashouts} />

        </div>
      }
    </Fragment>
  )
};

export default UserLevel;
